<template>
  <div class="medicine-list">
    <pull-refresh v-model="pullLoading" @refresh="refreshList">
      <list
        v-if="listInfo.length"
        v-model="loading"
        :finished="!hasNext"
        finished-text="没有更多了"
        @load="loadList"
        :immediate-check="false"
      >
        <div style="text-align: center; padding: 10vh 0" v-if="listInfo.length == 0 && !loading"></div>
        <page-layout>
          <div class="medicine-list__header" v-if="!pullLoading">
            <div class="medicine-list__title" v-if="showTip">选择用药人</div>
            <div class="medicine-list__subtitle">
              为保证用药安全，请添加实际使用药品的用药人，平台将严格保护用药人隐私。
            </div>
          </div>
          <div class="medicine-list__content">
            <div v-for="(item, index) in listInfo" :key="index" class="medicine-list__item">
              <div class="medicine-list__item-info" @click="handleSelect(item)">
                <div class="medicine-list__item-left">
                  <div class="medicine-list__item-check">
                    <i class="iconfont icon-check" :class="{ active: item.selected }"></i>
                  </div>
                  <div class="medicine-list__item-detail">
                    <div class="medicine-list__item-name">
                      {{ item.name }}
                      <span class="medicine-list__item-tag" v-if="item.relation === 'self'">本人</span>
                      <span class="medicine-list__item-tag" v-if="item.isVerified">已认证</span>
                    </div>
                    <div class="medicine-list__item-desc">
                      <p>{{ hideMiddleChars(item.phone) }}</p>
                      <p>{{ hideMiddleChars(item.idCard) }}</p>
                    </div>
                  </div>
                </div>
                <div class="medicine-list__item-right">
                  <span class="edit-icon"><van-icon name="edit" @click.stop="handleEdit(item)"/></span>
                  <span class="delete-icon"><van-icon name="delete" @click.stop="handleDelete(item)"/></span>
                </div>
              </div>
            </div>
          </div>
        </page-layout>
      </list>
      <empty v-if="!listInfo.length" description="暂无用药人，请添加" />
    </pull-refresh>
    <fixed-button text="+ 添加用药人" @emitEvent="handleAdd" />
    <van-dialog
      v-model="showDeleteDialog"
      title="提示"
      message="确定要删除该用药人吗？"
      show-cancel-button
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import { Icon as VanIcon, PullRefresh, List, Empty } from 'vant';
import FixedButton from '@/components/fixedButton';
import services from '@/service';
import { hideMiddleChars } from '@/lib/utils';
import eventBus from '@/lib/eventBus';

export default {
  name: 'MedicineList',
  components: {
    FixedButton,
    [VanIcon.name]: VanIcon,
    PullRefresh,
    List,
    Empty
  },
  computed: {
    showTip() {
      return ['mallPrescription'].includes(this.$router.currentRoute.name);
    }
  },
  data() {
    return {
      hideMiddleChars,
      pullLoading: false,
      loading: false,
      hasNext: true,
      queryParams: {
        pageNum: 0,
        pageSize: 10
      },
      listInfo: [],
      showDeleteDialog: false,
      deleteItem: null
    };
  },
  methods: {
    async refreshList() {
      this.pullLoading = true;
      this.listInfo = [];
      this.queryParams.pageNum = 0;
      this.hasNext = false;
      setTimeout(() => {
        this.loadList();
      }, 500);
    },
    async loadList() {
      this.queryParams.pageNum++;

      try {
        const res = await services.mall.getPatientRelList(this.queryParams);
        this.listInfo = [...this.listInfo, ...res.rows];
        this.hasNext = this.listInfo.length < res.total;
      } catch (error) {
        this.$toast('获取列表失败');
      } finally {
        this.pullLoading = false;
        this.loading = false;
      }
    },
    handleSelect(item) {
      if (!item.idCard || !item.phone || !item.name) {
        this.$toast('请先编辑完善用药人信息');
        return;
      }
      this.listInfo.forEach(i => {
        i.selected = i.id === item.patientRelId;
      });
      this.$emit('select', item);
    },
    handleAdd() {
      this.$router.push('/mall/medicine/add');
    },
    handleEdit(item) {
      this.$router.push(`/mall/medicine/edit/${item.patientRelId}`);
    },
    handleDelete(item) {
      this.deleteItem = item;
      this.showDeleteDialog = true;
    },
    async confirmDelete() {
      if (!this.deleteItem) return;
      try {
        await services.mall.deletePatientRel(this.deleteItem.patientRelId);
        this.refreshList();
        this.$toast('删除成功');
      } catch (error) {
        this.$toast('删除失败');
      } finally {
        this.deleteItem = null;
      }
    }
  },
  mounted() {
    this.refreshList();
  },
  created() {
    // 监听用药人更新事件
    eventBus.$on('medicine-updated', this.refreshList);
  },
  beforeDestroy() {
    // 移除事件监听
    eventBus.$off('medicine-updated', this.refreshList);
  }
};
</script>

<style lang="scss" scoped>
.medicine-list {
  .medicine-list__content {
    background: #f7f8fa;
    padding: 16px;
  }

  &__header {
    padding: $tb $lr;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
  }

  &__title {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 16px;
  }

  &__subtitle {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
  }

  &__item {
    background: #fff;
    padding: 16px;
    margin-bottom: 12px;
    border-radius: $radius;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;

    &:active {
      transform: scale(0.98);
    }

    &-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &-left {
      // display: flex;
      // align-items: center;
      // flex: 1;
    }

    &-check {
      margin-right: 20px;

      .icon-check {
        font-size: 24px;
        color: #dcdee0;
        transition: color 0.2s ease;

        &.active {
          color: $appcolor;
        }
      }
    }

    &-name {
      font-size: 17px;
      font-weight: 500;
      color: #1a1a1a;
      margin-bottom: 8px;
    }

    &-tag {
      display: inline-block;
      padding: 3px 8px;
      font-size: 12px;
      color: $appcolor;
      background: rgba($appcolor, 0.08);
      border-radius: 4px;
      margin-left: 10px;
      font-weight: normal;
    }

    &-desc {
      font-size: 14px;
      color: #666;
      line-height: 1.4;

      span {
        margin-right: 24px;
      }
    }

    &-right {
      display: flex;
      align-items: center;
      gap: 20px;

      .edit-icon {
        color: $appcolor;
      }

      .delete-icon {
        color: $red1;
      }

      .van-icon {
        font-size: 18px;
        opacity: 0.8;
        transition: all 0.2s ease;

        &:active {
          opacity: 1;
          transform: scale(1.1);
        }
      }
    }
  }
}
</style>
